// extracted by mini-css-extract-plugin
export default {"pageContainer":"PrivacyPage_pageContainer_133Qq"};